import React from 'react';

interface RoleBadgeProps {
    role: string;
    size?: 'sm' | 'md';
}

const roleConfig: Record<string, { label: string; color: string }> = {
    admin: { label: 'Quản trị viên', color: 'from-red-600 to-pink-600' },
    lop_truong: { label: 'Lớp trưởng', color: 'from-blue-600 to-cyan-600' },
    bi_thu: { label: 'Bí thư', color: 'from-purple-600 to-indigo-600' },
    lop_pho_hoc_tap: { label: 'Lớp phó HT', color: 'from-cyan-500 to-teal-500' },
    lop_pho_doi_song: { label: 'Lớp phó ĐS', color: 'from-teal-500 to-green-500' },
    pho_bi_thu: { label: 'Phó bí thư', color: 'from-indigo-500 to-purple-500' },
    thu_quy: { label: 'Thủ quỹ', color: 'from-yellow-500 to-amber-500' },
    uy_vien: { label: 'Ủy viên', color: 'from-green-500 to-emerald-500' },
    thanh_vien: { label: 'Thành viên', color: 'from-gray-500 to-gray-600' },
    user: { label: 'Thành viên', color: 'from-gray-500 to-gray-600' }
};

const RoleBadge: React.FC<RoleBadgeProps> = ({ role, size = 'sm' }) => {
    const config = roleConfig[role];

    if (!config) return null;

    const sizeClasses = size === 'sm'
        ? 'px-2 py-0.5 text-[10px]'
        : 'px-3 py-1 text-xs';

    return (
        <span
            className={`
                inline-block ${sizeClasses} rounded-full font-bold text-white whitespace-nowrap
                bg-gradient-to-r ${config.color}
                shadow-sm
            `}
            title={config.label}
        >
            {config.label}
        </span>
    );
};

export default RoleBadge;
